// Lib
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Canvas measurements
import measurementsRegistry from '../../measurementsStore/measurementsRegistry';

// Utils
import rafThrottle from '../../../../common/utils/lib/rafThrottle';
import { getViewportRect } from '../../../utils/dom/scrollableParentUtils';
import { hasChanged } from '../../../utils/react/propsComparisons';

// Selectors
import { inboxOpenStateSelector } from '../../../inbox/InboxContainer';

const inboxStateHasChanged = hasChanged('inboxState');

const mapStateToProps = createStructuredSelector({
    inboxState: inboxOpenStateSelector,
});

// FIXME Potentially use the measurements component
/**
 * This decorator passes a "layerRect" property to the PointerLayer component and updates
 * the layerRect whenever its size or scroll position changes.
 */
export default (DecoratedComponent) => {
    @connect(mapStateToProps)
    class PointerLayerRectObserver extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                layerRect: null,
            };
        }

        componentDidMount() {
            this.calculateLayerRect();
            this.attachEventListeners();
        }

        componentWillReceiveProps(nextProps) {
            if (inboxStateHasChanged(this.props, nextProps)) {
                this.throttledCalculateLayerRect();
            }
        }

        componentWillUnmount() {
            this.removeEventListeners();
        }

        attachEventListeners = () => {
            // Scroll and resize
            const canvasViewportElement = measurementsRegistry.getCanvasViewportDomElement();

            if (!canvasViewportElement) return;

            this.listenersAttached = true;

            canvasViewportElement.addEventListener('scroll', this.throttledCalculateLayerRect);
            window.addEventListener('resize', this.throttledCalculateLayerRect);
        };

        removeEventListeners = () => {
            if (!this.listenersAttached) return;

            const canvasViewportElement = measurementsRegistry.getCanvasViewportDomElement();
            canvasViewportElement &&
                canvasViewportElement.removeEventListener('scroll', this.throttledCalculateLayerRect);
            window.removeEventListener('resize', this.throttledCalculateLayerRect);

            this.listenersAttached = false;
        };

        calculateLayerRect = () => {
            const canvasViewportElement = measurementsRegistry.getCanvasViewportDomElement();

            if (!canvasViewportElement) return null;

            const layerRect = getViewportRect(canvasViewportElement);

            this.setState({ layerRect });
        };

        throttledCalculateLayerRect = rafThrottle(this.calculateLayerRect);

        render() {
            const { layerRect } = this.state;

            if (!layerRect) return null;

            return <DecoratedComponent {...this.props} layerRect={layerRect} />;
        }
    }

    return PointerLayerRectObserver;
};
